// TODO i don't know what these mean yet
export interface IListing {
    objectId: number;
    ad: string;
    bdmn: number; // bedroom
    bhmn: number; // bathroom
    br: string;
    cl: number;
    cm: string;
    fd: number;
    ld: number;
    lls: string;
    lpmn: number;
    md: string | null;
    ml: string | null;
    mlan: number;
    mli: string | null;
    pc: string;
    pi: string;
    pid: string;
    sid: number;
    sp: number;
    st: string;
    tlan: number;
    geometry?: any; // not sure if this is esri geometry?
    viewDetailsInProgress?: boolean; // only used in multi listing popup
    viewPhotosInProgress?: boolean; // only used in multi listing popup
    ht?: string; // heat: only in multilistings
    ga?: number; // garage: only in multilistings
    wf?: number; // waterfront: only in multilistings
    yb?: number; // age: only in multilistings
}

export class Listing implements IListing {
    public objectId = -1;
    public ad = '';
    public bdmn = -1;
    public bhmn = -1;
    public br = '';
    public cl = -1;
    public cm = '';
    public fd = -1;
    public ld = -1;
    public lls = '';
    public lpmn = -1;
    public md = null;
    public ml = null;
    public mlan = -1;
    public mli = null;
    public pc = '';
    public pi = '';
    public pid = '';
    public sid = -1;
    public sp = -1;
    public st = '';
    public tlan = -1;
    public geometry = null;
    public viewDetailsInProgress?: boolean;
    public viewPhotosInProgress?: boolean;
    public ht = undefined;
    public ga = undefined;
    public wf = undefined;
    public yb = undefined;
    constructor(
        featureProperties: any,
        featureGeometry?: any,
    ) {
        this.objectId = featureProperties.OBJECTID;
        this.ad = featureProperties.ad;
        this.bdmn = featureProperties.bdmn;
        this.bhmn = featureProperties.bhmn;
        this.br = featureProperties.br;
        this.cl = featureProperties.cl;
        this.cm = featureProperties.cm;
        this.fd = featureProperties.fd;
        this.ld = featureProperties.ld;
        this.lls = featureProperties.lls;
        this.lpmn = featureProperties.lpmn;
        this.md = featureProperties.md;
        this.ml = featureProperties.ml;
        this.mlan = featureProperties.mlan;
        this.mli = featureProperties.mli;
        this.pc = featureProperties.pc;
        this.pi = featureProperties.pi;
        this.pid = featureProperties.pid;
        this.sid = featureProperties.sid;
        this.sp = featureProperties.sp;
        this.st = featureProperties.st;
        this.tlan = featureProperties.tlan;
        this.ht = featureProperties.ht;
        this.ga = featureProperties.ga;
        this.wf = featureProperties.wf;
        this.yb = featureProperties.yb;
        this.geometry = featureGeometry;
    }
}

